import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "hourlyFields",
    "salaryFields",
    "monthlyInput",
    "yearlyInput",
    "hourlyPreview",
    "hourlyPreviewValue",
  ]

  static values = {
    weeklyHours: { type: Number, default: 0 },
  }

  toggleType(event) {
    const type = event.target.value
    const hidingHourly = type !== "hourly"

    this.hourlyFieldsTarget.classList.toggle("hidden", hidingHourly)
    if (this.hasSalaryFieldsTarget) {
      this.salaryFieldsTarget.classList.toggle("hidden", !hidingHourly)
    }

    const containerToClear = hidingHourly
      ? this.hourlyFieldsTarget
      : this.hasSalaryFieldsTarget
        ? this.salaryFieldsTarget
        : null
    this._clearInputs(containerToClear)
  }

  _clearInputs(container) {
    if (!container) return
    container.querySelectorAll("input").forEach((input) => {
      if (input.type !== "hidden") input.value = ""
    })
  }

  monthlyChanged() {
    const monthly = parseFloat(this.monthlyInputTarget.value)
    if (isNaN(monthly)) return

    this.yearlyInputTarget.value = (monthly * 12).toFixed(2)
    this.updateHourlyPreview(monthly * 12)
  }

  yearlyChanged() {
    const yearly = parseFloat(this.yearlyInputTarget.value)
    if (isNaN(yearly)) return

    this.monthlyInputTarget.value = (yearly / 12).toFixed(2)
    this.updateHourlyPreview(yearly)
  }

  updateHourlyPreview(yearlySalary) {
    if (!this.hasHourlyPreviewValueTarget) return
    if (this.weeklyHoursValue <= 0) return

    const hourly = yearlySalary / 52.0 / this.weeklyHoursValue
    this.hourlyPreviewValueTarget.textContent = hourly.toFixed(2)
  }
}
